import React from 'react';

export const CalloutBlock: React.FunctionComponent = props => <div className="gik-callout-block">{props.children}</div>;
